export default function inclusion(value = '', options = {}) {
  if (['', undefined, null].includes(value)) {
    return false;
  }

  if ((options.list || []).map((option) => String(option)).includes(value)) {
    return !!options.negative;
  }

  return !options.negative;
}

inclusion.message = function message(value, options = {}) {
  if (options.message) {
    return options.message;
  }

  if (!options.list) {
    return 'precisa ser uma opção válida';
  }

  const list = options.list.join('", "').replace(/(", ")(?!.*\1)/, '" e "');

  if (options.negative) {
    return `precisa ser diferente de "${list}"`;
  }

  return `precisa ser um valor entre "${list}"`;
};
